import React,{useState,useEffect} from 'react';
import { Form, Input, Button, Select,Card, Row, Col } from 'antd';
import { WorkstationCategoryDTO } from '@gtpl/shared-models/production-management';
import { WorkstationCategoryService} from '@gtpl/shared-services/production';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { Link, useHistory } from "react-router-dom";

import './workstation-category-form.css';

/* eslint-disable-next-line */
export interface WorkstationCategoryFormProps {
  workstationCategoryData:WorkstationCategoryDTO;
  updateWorkstationCategory:(workstationCategory:WorkstationCategoryDTO)=>void;
  isUpdate:boolean;
  closeForm: () => void;
}


export function WorkstationCategoryForm(props: WorkstationCategoryFormProps) {
  const [form] = Form.useForm();
  let history = useHistory();

  let createdUser="";
  if(!props.isUpdate){
    createdUser= localStorage.getItem("createdUser");
  }
  const [disable, setDisable] = useState<boolean>(false) 
  const workstationCategoryService = new WorkstationCategoryService()

  const createWorkstationCategory=(workstationCategoryData:WorkstationCategoryDTO)=>{
    setDisable(true)
    workstationCategoryService.createWorkstationCategory(workstationCategoryData).then(res => {
      setDisable(false)
      if (res.status) {
        AlertMessages.getSuccessMessage('Workstation Category Created Successfully');
        history.push("/workstation-category-grid");
        onReset();
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setDisable(false)
      AlertMessages.getErrorMessage(err.message);
    })
  }

  const onReset=()=>{
    form.resetFields();
    
  }

  const saveData = (values: WorkstationCategoryDTO) => {
    setDisable(false)
    if(props.isUpdate){
      console.log(values)
      props.updateWorkstationCategory(values);
    }else{
      setDisable(false)
      console.log(values)
      createWorkstationCategory(values);
    }
  
  };

  return (
    <Card title={<span style={{color:'white'}}> Workstation Categories</span>} style={{textAlign:'center'}} headStyle={{backgroundColor: '#69c0ff', border: 0 }} extra={props.isUpdate==true?"":<Link to='/workstation-category-grid' ><Button className='panel_button' >View </Button></Link>}
    >
      <Form layout="vertical" form={form} initialValues={props.workstationCategoryData} name="control-hooks" onFinish={saveData}>
      <Form.Item name="workstationCategoryId" style={{display:"none"}} >
        <Input hidden/>
      </Form.Item>
    <Form.Item style={{display:"none"}} name="createdUser"  initialValue={createdUser}>
      <Input hidden/>
    </Form.Item>
    <Row>
        
    <Col xs={{span:24}} sm={{span:24}} md={{span:8}} lg={{span:8}} xl={{span:8}}>
            <Form.Item
                name="workstationCategory"
                label="Workstation Category Name"
                rules={[
                  {
                    required: true,message:'Workstation Category Name is required'
                    
                  },
                  {
                    pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z ]*$/,
                    message: `Should contain only alphabets.`
                  }
                ]}>
                <Input/>
              </Form.Item>
        </Col>
      </Row>
     
        <Col span={24} style={{ textAlign: 'right' }}>
          
            <Button type="primary"disabled={disable} htmlType="submit" >
              Submit
            </Button>
            {(props.isUpdate===false) &&
         <Button htmlType="button" style={{ margin: '0 14px' }} onClick={onReset}>
            Reset
          </Button>
          }
      
            
        </Col>
      </Form>
    </Card>
  );
}

export default WorkstationCategoryForm;